import styled from "styled-components";

export const Paragraph = styled.p`
    padding: 0 20px 20px 20px;
`